import { useField } from "formik";
import React from "react";

export type ReadOnlyTextFieldProps = Readonly<{
  name: string;
}>;

export const ReadOnlyTextField = (props: ReadOnlyTextFieldProps) => {
  const [field] = useField(props);
  return <span>{field.value ?? ""}</span>;
};
